import IbBachelor from './IbBachelor';

export default IbBachelor;